import { QuestroomCancelationTypeEnum } from '../questroom/enum/questroom-cancelation-type.enum';
import { PrepaymentTypeEnum } from '../slot/enum/prepayment-type.enum';

export const defaultRule = {
    title: 'System rule',
    prepayment: 0,
    prepaymentType: PrepaymentTypeEnum.NO,
    cancelationRule: QuestroomCancelationTypeEnum.MIN_PRICE,
    minHoursForFreeCanceling: 8,
    minHoursForBooking: 48,
    minMinutesForBooking: 48 * 60,
    minHoursForFullFine: 0,
    blockingHours: 2,
    blockingMinutes: 2 * 60,
    openSlotWhenUserInCalendar: true,
    clientCanCancel: true,
    prepayForTourists: false,
    cancelationAmount: 0,
};
